export function timeInMilliseconds(time: number, interval: 'seconds' | 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years'): number {
    if (interval === 'seconds') return time * 1000;
    if (interval === 'minutes') return time * 60 * 1000;
    if (interval === 'hours') return time * 60 * 60 * 1000;
    if (interval === 'days') return time * 24 * 60 * 60 * 1000;
    if (interval === 'weeks') return time * 7 * 24 * 60 * 60 * 1000;
    if (interval === 'months') return time * 4 * 7 * 24 * 60 * 60 * 1000;
    if (interval === 'years') return time * 12 * 4 * 7 * 24 * 60 * 60 * 1000;
}
